import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginModel } from '../models/login.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private http: HttpClient) { }
  // private baseUrl = 'https://globalsources-erp-staging-23176447.dev.odoo.com/odoo/user';
  // private baseUrl = 'https://globalsources-erp-staging-24532743.dev.odoo.com/odoo/user';
  // private baseUrl = 'https://globalsources-erp.odoo.com/odoo/user';
  private baseUrl = environment.apiUrl + '/user';
  
  authenticate(loginRequest: LoginModel): Observable<any> {
    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: loginRequest   // ✅ pass model object directly
    };
    return this.http.post(this.baseUrl + '/signin', body);
    // return this.http.post('/odoo/jwt/auth', body);
    //  {
    //   "db": "global_live_aug_18",
    //   "login": "abhijith@globalsources.com.sa",
    //   "password": "admin"
    // }  
    // return this.http.post('/odoo/get/auth', body);
  }
  registerUser(loginRequest: LoginModel): Observable<any> {
    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: loginRequest   // ✅ pass model object directly
    };
    // return this.http.post(this.baseUrl + '/auth', body);
    return this.http.post('/odoo/jwt/auth', body);
    //  {
    //   "db": "global_live_aug_18",
    //   "login": "abhijith@globalsources.com.sa",
    //   "password": "admin"
    // }  
    // return this.http.post('/odoo/get/auth', body);
  }

}
